import { PhaseDto } from '../api/model';

const AGILE_ARTEFACT_NAME_KEYS = new Set([
    'agileartefact',
    'agileartefacts',
    'agileartifact',
    'agileartifacts',
    'agileartefakt',
    'agileartefakte',
]);

export function getPhaseDisplayName(phase?: Pick<PhaseDto, 'customName' | 'name' | 'type' | 'id'> | null): string {
    if (!phase) return 'Phase';
    const fallback = phase.id != null ? `Phase ${phase.id}` : 'Phase';
    return (phase.customName || phase.name || phase.type || fallback)
        .toString()
        .replaceAll('_', ' ') || 'Phase';
}

export function isAgileArtefactDeliverable(deliverable?: { name?: string | null } | null): boolean {
    if (!deliverable?.name) return false;
    const normalized = deliverable.name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '');

    return AGILE_ARTEFACT_NAME_KEYS.has(normalized);
}

// If we have multiple phases with the same name, we need to disambiguate them. so user needs to identify which phase is what. We can do this by adding the date range to the name. If we don't have a date range, we can add the phase id to the name.
export function getPhaseLabel(phase: PhaseDto, allPhases: PhaseDto[]): string {
    const baseName = getPhaseDisplayName(phase);

  const hasDuplicate = allPhases.some(
    (p) =>
      p.id !== phase.id &&
        getPhaseDisplayName(p) === baseName
  );

  if (!hasDuplicate) return baseName;

  // Use date range
  if (phase.startTime && phase.endTime) {
    const fmt = (d: string) =>
      new Date(d.toString()).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
      });
    return `${baseName} (${fmt(phase.startTime.toString())} – ${fmt(phase.endTime.toString())})`;
  }

  return `${baseName} #${phase.id}`;
}
